import { JobAvailabilityType } from 'us-web-services';
import { availabilityTypeConstant } from '../constants/Booking';

export const getAvailabilityTypeId = (availabilityType?: string): number => {
  const typeMapping: Record<string, number> = {
    [JobAvailabilityType.partTime]: availabilityTypeConstant.find((a: { type?: string }) => a.type === JobAvailabilityType.partTime)?.id ?? 0,
    [JobAvailabilityType.fullTime]: availabilityTypeConstant.find((a: { type?: string }) => a.type === JobAvailabilityType.fullTime)?.id ?? 0,
  };

  return typeMapping[availabilityType || ''] || 0;
};
